"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  listStyleType: 'none',
  margin: 0,
  padding: 0
});
var DOT_CSS = (0, _glamor.css)({
  position: 'relative',
  '& > input': {
    height: '100%',
    left: 0,
    margin: 0,
    opacity: 0,
    position: 'absolute',
    top: 0,
    width: '100%'
  }
});

var Dots = function Dots(_ref) {
  var children = _ref.children,
      className = _ref.className,
      index = _ref.index,
      itemClassName = _ref.itemClassName,
      numItems = _ref.numItems,
      scrollTo = _ref.scrollTo;
  return _react.default.createElement("ul", {
    className: (0, _classnames.default)(ROOT_CSS + '', (className || '') + '')
  }, new Array(numItems).fill().map(function (_, itemIndex) {
    return _react.default.createElement(Dot, {
      "aria-label": itemIndex + 1,
      checked: itemIndex === index,
      className: itemClassName,
      index: itemIndex,
      key: itemIndex,
      scrollTo: scrollTo
    }, children);
  }));
};

var Dot =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dot, _React$Component);

  function Dot(props) {
    var _this;

    _classCallCheck(this, Dot);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dot).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Dot, [{
    key: "handleChange",
    value: function handleChange() {
      var _this2 = this;

      this.props.scrollTo(function () {
        return _this2.props.index;
      });
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(evt) {
      var keyCode = evt.keyCode;

      if (keyCode === 13 || keyCode === 32) {
        evt.preventDefault();
        evt.stopPropagation();
        this.handleChange();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ariaLabel = _this$props['aria-label'],
          checked = _this$props.checked,
          children = _this$props.children,
          className = _this$props.className;
      return _react.default.createElement("li", {
        className: (0, _classnames.default)(DOT_CSS + '', (className || '') + '')
      }, _react.default.createElement("input", {
        "aria-label": ariaLabel,
        "aria-pressed": checked,
        checked: checked,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        role: "button",
        type: "checkbox"
      }), children && children());
    }
  }]);

  return Dot;
}(_react.default.Component);

var _default = function _default(props) {
  return _react.default.createElement(_Context.default.Consumer, null, function (_ref2) {
    var index = _ref2.index,
        numItems = _ref2.numItems,
        scrollTo = _ref2.scrollTo;
    return _react.default.createElement(Dots, _extends({
      index: index,
      numItems: numItems,
      scrollTo: scrollTo
    }, props));
  });
};

exports.default = _default;